/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Checkout/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Appointments from './Appointments/index'
import MinimiseAction from './MinimiseAction/index'
import React from 'react'
import Tabs from './Tabs/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaIconLogout from 'DesignSystem/Svgs/TysiaIconLogout/index'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function Checkout({
  children,
  viewPath = "/App/Account/WaitingRoom/Content/Content/Checkout"
  
}) {
  let isMedia = useIsMedia()
  let flow = fromFlow.useFlow()
let dtColorsOrange100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.orange.100'
        })
let dtColorsOrange400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.orange.400'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<div
  data-testid="Checkout.Vertical"
  data-view-path={viewPath}
 style={{'--bc-5-1SER7P': dtColorsOrange100,'--bc-6-1SER7P': dtColorsOrange400,'--fg-1-1SER7P': flow.has(fromFlow.normalizePath(viewPath, 'Appointments/No')) ? 0 : 1,'--fs-2-1SER7P': flow.has(fromFlow.normalizePath(viewPath, 'Appointments/No')) ? 0 : 1,'--fb-3-1SER7P': flow.has(fromFlow.normalizePath(viewPath, 'Appointments/No')) ? "auto" : "100%",'--w-4-1SER7P': isMedia.mobile ? "100%" : "250px"}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Checkout.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-7-1SER7P': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-8-1SER7P': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbc-9-1SER7P': dtColorsOrange400,'--bc-5-1SER7P': dtColorsOrange100,'--bbw-10-1SER7P': flow.has(fromFlow.normalizePath(viewPath, 'Appointments/No')) ? "0px" : "1px"}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaIconLogout
  viewPath={`${viewPath}/TysiaIconLogout`}
 width={16}
 height={16}
 fill={dtColorsNeutral900}
/>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h5"
 marginLeft={4}
 text="Checkout"
/>
<Tabs
  viewPath={`${viewPath}/Tabs`}
/>
<MinimiseAction
  viewPath={`${viewPath}/MinimiseAction`}
/>
</div>
<Appointments
  viewPath={`${viewPath}/Appointments`}
/>
</div>
{children}
</React.Fragment>)
}